import store from "@/store";
import Util from "@/utils/utils";

export const mixinTrial = {
    data: () => ({}),
    computed: {
        expiredTrialTicketMessage: () => '아쉽지만 체험권의 이용 시작 가능 기간이 지나, 이어서 진행하실 수 없습니다.<br>티켓을 구매하시거나 보유 중인 티켓으로<br>여행을 시작해 주세요.',
        trialResumeAlertMessage: () => '체험권 이어하기를 통해<br/>더 많은 미션을 경험해 보세요!',
        hasActiveTrial: () => store.state.client.contract.trialStatus === 'ACTIVE',
        trialDays() {
            return store.state.client.contract.trialDays || 0
        },
        expiredTrial() {
            return store.state.client.contract.expiredTrial;
        },
        expiredTrialTicket() {
            return store.state.client.contract.expiredTrialTicket;
        },
        trialInactiveDateTime() {
            return store.state.client.contract.trialInactiveDateTime
        },
        trialActiveDateTime() {
            return store.state.client.contract.trialActiveDateTime
        },
        endedTrial() {
            // 트라이얼 이어하기 이후 이용 종료
            return store.state.client.contract.trialStatus === 'ENDED' && store.getters.useOrdDtl.travelYn == 'N'
        },
        waitTrial() {
            return store.state.client.contract.trialStatus === 'JOIN' && !store.getters.isBeforeApplResultYn
                      && !store.state.client.contract.expiredTrialTicket
        },
        directTicketOrderStatus() {
            // 트라이얼 이어하기 이후 이용 종료
            return store.state.client.contract.trialStatus === 'ENDED' || (this.hasActiveTrial && this.expiredTrial)
        },
        hasTrial() {
            return !!store.state.client.contract.trialStatus;
        },
        serverErrorMessage() {
            return '죄송합니다. 요청 처리 중 문제가 발생했습니다. 잠시 후 다시 시도해주세요.'
        }
    },
    methods: {
        isTrialDayExceeded(selectedDays) {
            if (this.hasActiveTrial) return selectedDays >= this.trialDays
            return false
        },
        makeAlertMessage() {
            return `
          <div class="alert-temp-01">
            <div>
              <img src="${this.getImage('guide/togather.svg')}" />
            </div>
            <h6 class="tit">
              후유마음여행 ${this.trialDays}일 무료체험<br />기간이 종료 됐어요
            </h6>
            <p class="sub-txt ma-0">후유와 함께한 마음여행은 어떠셨나요?</p>
          </div>
            `
        },
        /**
         * 체험권 종료 이후 이어하기
         * @param hasEnded
         */
        continueTrial() {
            // 체험권 종료 D+1부터 D+14까지 노출
            const showTrialDate = Util.Date.add(this.trialInactiveDateTime, 14, 'day', 'YYYY-MM-DD');
            const isAfterTrial = Util.Date.isBefore(showTrialDate); // true면 기간 지나지 않음

            const cookieKey = 'show-continue-trial';
            const today = Util.Date.toDate(new Date(), 'YYYY-MM-DD');
            const shownDate = this.$cookies.get(cookieKey);

            // 노출기간이 지나지 않았거나, 이미 오늘 얼럿을 본 경우 → 얼럿 없이 바로 실행
            if (!isAfterTrial || shownDate === today) {
                return;
            }

            // 얼럿 보여주고 확인 시 쿠키 저장
            this.$alert(this.makeAlertMessage(false), {
                actions: {
                    true: {
                        text: '다음',
                        handle: () => {
                            this.$cookies.set(cookieKey, today, { expires: 1 });
                            this.dispatchBalanceCheckAvailable();
                        }
                    }
                },
                html: true // HTML 렌더링 활성화
            })
        },
        /**
         * 이어하기 이후 서비스 추가 이용 시
         * @param hasEnded
         */
        continueDirectTicket() {
            this.dispatchBalanceCheckAvailable(true)
        },
        expiredTrialTicketAlert (msg) {
            this.$alert(msg).then(() => {
                /// 티켓 리스트 갱신
                store.commit('incrementTicketRefreshTrigger')
                // 주문정보 갱신
                store.dispatch('getContractedGoodsInfo')
                store.dispatch('getUseOrdDtl', true)
                this.movePage('/fo/myTicket')
            })
        },
        dispatchBalanceCheckAvailable(hasEnded) {
            if (!hasEnded && this.expiredTrialTicket) {
                return this.expiredTrialTicketAlert(this.expiredTrialTicketMessage)
            }
            store.dispatch('isBalanceCheckAvailable')
                .then(res => {
                    if (res.success) {
                        const { siteName, pointUnit, paymentAmount, paymentAvailable } = res.data;
                        let $successMessage = `${siteName}를 통해 ${paymentAmount}${pointUnit}로 결제하면</br>여행을 계속할 수 있어요.`;
                        $successMessage += hasEnded
                            ? '</br>(결제 후 취소 및 환불 불가)</br>구매하시겠습니까?'
                            : '</br>이어서 진행할까요?</br>(결제 후 취소 및 환불 불가)';

                        this.$confirm($successMessage, {
                            persistent: false,
                            showClose: true,
                            actions: {  false: { text: '아니오' }, true: { text: '진행하기' } }
                        }).then(yes => {
                            if (yes) {
                                if (!paymentAvailable) {
                                    const $failMessage = `${siteName}의 보유 ${paymentAmount}${pointUnit}가</br>부족해서 이용이 어려워요.`;
                                    this.$alert($failMessage);
                                    return
                                }
                                if (hasEnded) return this.directTicketAndDeduct();
                                else this.deductHappymintPoints();
                            }
                        });
                    } else {
                        if (res.code === "3000") {
                            this.expiredTrialTicketAlert(res.msg);
                        } else {
                            this.$alert(res.msg);
                        }
                    }
                })
                .catch(() => this.$alert(this.serverErrorMessage))
        },
        deductHappymintPoints() {
            store.dispatch('executePayment')
                .then(res => {
                    if (res.success) {
                        const { siteName, pointUnit, paymentAmount, paymentAvailable } = res.data;

                        if (paymentAvailable) {
                            const $successMessage = `${siteName}를 통해 ${paymentAmount}${pointUnit}가 차감되었어요.</br>마음여행이 계속됩니다.`;
                            this.$alert($successMessage);
                        } else {
                            const $failMessage = `${siteName}의 보유 ${paymentAmount}${pointUnit}가</br>부족해서 이용이 어려워요.`;
                            this.$alert($failMessage);
                        }
                    } else {
                        if (res.code === "3000") {
                            this.expiredTrialTicketAlert(res.msg);
                        } else {
                            this.$alert(res.msg);
                        }
                    }
                })
                .catch(() => this.$alert(this.serverErrorMessage))
                .finally(() =>{
                    /// 티켓 리스트 갱신
                    store.commit('incrementTicketRefreshTrigger')
                    // 주문정보 갱신
                    store.dispatch('getContractedGoodsInfo')
                    store.dispatch('getUseOrdDtl', true)
                    store.dispatch('getTodayPlanList', true)
                })
        },
        directTicketAndDeduct() {
            store.dispatch('continueDirectTicket')
                .then(res => {
                    if (res.success) {
                        const {siteName, pointUnit, paymentAmount, paymentAvailable} = res.data
                        if (paymentAvailable) {
                            const $successMessage = `${siteName}를 통해 ${paymentAmount}${pointUnit}가 차감되었어요.</br>보유 티켓을 시작해 주세요.`
                            this.$alert($successMessage)
                        } else {
                            const $failMessage = `${siteName}의 보유 ${pointUnit}가</br>부족해서 이용이 어려워요.`
                            this.$alert($failMessage)
                        }
                    } else {
                        if (res.code === "3000") {
                            this.expiredTrialTicketAlert(res.msg);
                        } else {
                            this.$alert(res.msg)
                        }
                    }
                })
                .catch(() => this.$alert(this.serverErrorMessage))
                .finally(() =>{
                    this.getBeforeAppResultList()
                    /// 티켓 리스트 갱신
                    store.commit('incrementTicketRefreshTrigger')
                    // 주문정보 갱신
                    store.dispatch('getContractedGoodsInfo')
                    store.dispatch('getUseOrdDtl', true)
                    store.dispatch('getTodayPlanList', true)
                })
        }
    }
}

